<div class="grid grid-cols-1 md:grid-cols-5 gap-6 mb-24">
  <ng-container *ngIf="!isLoading; else loading">
    <div class="col-span-1 md:col-span-3 space-y-6">
      <div class="bg-white rounded-md p-6 relative">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-xl font-bold text-gray-800">Presentación</h2>
          <button
            type="button"
            (click)="toggleEditPresentation()"
            class="text-gray-500 hover:text-primary cursor-pointer"
          >
            <ng-icon
              *ngIf="!isEditingPresentation"
              name="heroPencilSquare"
              size="20"
            ></ng-icon>
            <ng-icon
              *ngIf="isEditingPresentation"
              name="heroXMark"
              size="20"
            ></ng-icon>
          </button>
        </div>
        <p *ngIf="!isEditingPresentation" class="text-gray-600">
          <span *ngIf="profile.personalInformation; else noPresentation">
            {{ profile.personalInformation }}
          </span>
          <ng-template #noPresentation>
            <span class="italic text-gray-400">
              Aún no has agregado una presentación. Comparte tu experiencia y
              habilidades para destacar frente a los reclutadores.
            </span>
          </ng-template>
        </p>
        <form
          class="flex flex-col items-end w-full"
          *ngIf="isEditingPresentation"
          [formGroup]="presentationForm"
          (ngSubmit)="savePresentation()"
          class="space-y-4"
        >
          <app-input-textarea
            placeholder="Escribe tu presentación"
            [control]="presentationForm.get('personalInformation')"
          />
          <div class="mb-5"></div>
          <div class="col-span-2 flex justify-end mt-4">
            <app-loading-button
              [text]="'Guardar'"
              [loading]="loadingSavePresentation"
              type="submit"
            >
            </app-loading-button>
          </div>
        </form>
      </div>
      <div class="bg-white rounded-md p-6 relative">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-xl font-bold text-gray-800">Información personal</h2>
          <button
            type="button"
            (click)="toggleEditPersonalInfo()"
            class="text-gray-500 hover:text-primary cursor-pointer"
          >
            <ng-icon
              *ngIf="!isEditingPersonalInfo"
              name="heroPencilSquare"
              size="20"
            ></ng-icon>
            <ng-icon
              *ngIf="isEditingPersonalInfo"
              name="heroXMark"
              size="20"
            ></ng-icon>
          </button>
        </div>
        <div
          *ngIf="!isEditingPersonalInfo"
          class="grid grid-cols-2 gap-4 text-sm"
        >
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >Departamento:</label
            >
            <p class="text-gray-600">
              <ng-container *ngIf="profile.departament; else noDepartament">
                {{ profile.departament }}
              </ng-container>
              <ng-template #noDepartament>
                <span class="italic text-gray-400"
                  >Aún no has registrado tu departamento</span
                >
              </ng-template>
            </p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >Provincia:</label
            >
            <p class="text-gray-600">
              <ng-container *ngIf="profile.province; else noProvince">
                {{ profile.province }}
              </ng-container>
              <ng-template #noProvince>
                <span class="italic text-gray-400"
                  >Agrega tu provincia para completar tu perfil</span
                >
              </ng-template>
            </p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >Distrito:</label
            >
            <p class="text-gray-600 capitalize">
              <ng-container *ngIf="profile.district; else noDistrict">
                {{ profile.district }}
              </ng-container>
              <ng-template #noDistrict>
                <span class="italic text-gray-400">Registra tu distrito</span>
              </ng-template>
            </p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >Dirección:</label
            >
            <p class="text-gray-600">
              <ng-container *ngIf="profile.address; else noAddress">
                {{ profile.address }}
              </ng-container>
              <ng-template #noAddress>
                <span class="italic text-gray-400"
                  >Añade una dirección para mayor precisión</span
                >
              </ng-template>
            </p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >Teléfono:</label
            >
            <p class="text-gray-600">
              <ng-container *ngIf="profile.telfOne; else noTelf">
                {{ profile.telfOne }}
              </ng-container>
              <ng-template #noTelf>
                <span class="italic text-gray-400"
                  >Registra un teléfono de contacto</span
                >
              </ng-template>
            </p>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >DNI:</label
            >
            <p class="text-gray-600">
              <ng-container *ngIf="profile.identificationDocument; else noDni">
                {{ profile.identificationDocument }}
              </ng-container>
              <ng-template #noDni>
                <span class="italic text-gray-400"
                  >Aún no has registrado tu DNI</span
                >
              </ng-template>
            </p>
          </div>
        </div>
        <form
          *ngIf="isEditingPersonalInfo"
          [formGroup]="personalInfoForm"
          (ngSubmit)="savePersonalInfo()"
          class="grid grid-cols-2 gap-4"
        >
          <app-input-select
            label="Departamento"
            placeholder="Departamento"
            [control]="personalInfoForm.get('idDepartament')"
            [options]="departaments"
          >
          </app-input-select>
          <app-input-select
            label="Provincia"
            placeholder="Provincia"
            [control]="personalInfoForm.get('idProvince')"
            [options]="provinces"
          >
          </app-input-select>
          <app-input-select
            label="Distrito"
            placeholder="Distrito"
            [control]="personalInfoForm.get('idDistrict')"
            [options]="districts"
          >
          </app-input-select>
          <app-input-text
            label="Dirección"
            placeholder="Dirección"
            [control]="personalInfoForm.get('address')"
            class="col-span-2"
          />
          <app-input-text
            label="Teléfono"
            placeholder="Teléfono"
            [control]="personalInfoForm.get('telfOne')"
          />
          <app-input-text
            label="DNI"
            placeholder="DNI"
            [control]="personalInfoForm.get('identificationDocument')"
          />
          <div class="col-span-2 flex justify-end mt-4">
            <app-loading-button
              [text]="'Guardar'"
              [loading]="loadingSavePersonalInfo"
              type="submit"
            >
            </app-loading-button>
          </div>
        </form>
      </div>
      <div
        *ngIf="(profile?.representatives?.length || 0) > 0"
        class="bg-white rounded-md p-6"
      >
        <h2 class="text-xl font-bold text-gray-800 mb-4">
          Compañías representadas
        </h2>
        <ul class="space-y-3">
          <li
            *ngFor="let rep of profile?.representatives"
            class="p-3 border border-gray-200 rounded-lg flex justify-between items-center"
          >
            <div>
              <p class="font-semibold text-gray-800">
                {{ rep.companyComercialName }}
              </p>
              <p class="text-sm text-gray-600">Rol: {{ rep.role }}</p>
            </div>
            <span class="bg-primary text-white text-xs px-3 py-1 rounded-full">
              Activo
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-span-1 md:col-span-2 space-y-6">
      <div
        class="bg-gradient-to-r from-primary to-purple-600 text-white rounded-md p-6"
      >
        <h3 class="text-xl font-bold mb-2">Codijobs</h3>
        <p class="text-sm mb-4">
          Encuentra tu próximo empleo con nosotros. Miles de oportunidades
          esperándote.
        </p>
        <button
          (click)="goToHome()"
          class="bg-white text-primary font-semibold px-4 py-2 rounded-lg hover:bg-gray-100 transition cursor-pointer"
        >
          Ver ofertas
        </button>
      </div>
      <div class="bg-white rounded-md p-6">
        <h3 class="text-lg font-bold text-gray-800 mb-2">¿Buscas talento?</h3>
        <p class="text-gray-600 mb-4">
          Publica tu oferta en Codijobs y encuentra el mejor perfil para tu
          empresa.
        </p>
        <button
          (click)="goToCompany()"
          class="bg-primary text-white px-4 py-2 rounded-lg hover:opacity-90 transition"
        >
          Publicar oferta
        </button>
      </div>
    </div>
  </ng-container>
  <ng-template #loading>
    <div
      class="col-span-5 flex items-center justify-center w-full min-h-[600px]"
    >
      <app-loading></app-loading>
    </div>
  </ng-template>
</div>
